<template>
  <div>
    <label class="kyc-sub-title">{{ label }}</label>
    <div
      class="imi-container"
      :style="imageStatus ? 'border-color: rgb(var(--rgb-system-primary));' : 'border-color: rgba(var(--rgb-text-grey-color), .7);'"
    >
      <div class="imi-sub-container">
        <img :src="`/img/${dbName}.png`"  alt="Зураг" width="150" class="rounded" />
        <p class="text-center card-text mt-4">JPG, JPEG, PNG (Max: 5mb)</p>
        <label class="d-flex justify-content-center mt-xl-3">
            <span class="ic-button-wrapper card-button">{{$t('helper.upload-image')}}</span>
            <input :name="dbName" type="file" class="sr-only" accept=".jpg,.jpeg,.png,image/jpeg,image/png" @change="uploadImage($event)"/>
        </label>
      </div>
    </div>
    <p v-if="error" class="error-message">Зөвхөн JPG, JPEG, PNG өргөтгөлтэй зураг оруулна уу.</p>
    <p v-show="imageStatus" class="success-message">Зураг орсон байна.</p>
  </div>
</template>

<script>
const ALLOWED_MIME_TYPES = ["image/jpeg", "image/png"];

export default {
  props: {
    label: { type: [String] },
    id: String,
    dbName: { String }
  },
  data() {
    return {
      image: null,
      imageStatus: false,
      error: false
    }
  },
  methods: {
    uploadImage(event) {
      const file = event.target.files[0]
      if (!file) return
      if (!ALLOWED_MIME_TYPES.includes(file.type)) {
        this.error = true
        event.target.value = ""
        return
      }
      this.error = false
      this.image = file
      this.imageStatus = true
    }
  },
  watch: {
    image() {
      this.$emit('return', this.image)
    }
  }
}
</script>

<style lang='scss' scoped>
@import "./ImageInput.scss";
</style>
